import { Link, Navigate, useSearchParams } from 'react-router-dom';

function formatUsdCents(amountCents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amountCents / 100);
}

export default function GiveThankYou() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') || searchParams.get('redirect_status') || '';
  const donationType = searchParams.get('type') === 'monthly_donation' ? 'monthly' : 'one-time';
  const amountCents = Number(searchParams.get('amount_cents') || '0');
  const donorEmail = searchParams.get('email') || '';

  if (!status) {
    return <Navigate to="/give" replace />;
  }

  const isSuccess = status === 'succeeded';

  return (
    <div className="page-shell confirmation-page">
      <section className="confirmation-card">
        <p className="home-section-label">{donationType === 'monthly' ? 'Monthly giving' : 'Donation received'}</p>
        <h1>
          {isSuccess
            ? donationType === 'monthly'
              ? 'Your monthly gift is active.'
              : 'Thank you for supporting Victoria\'s Place.'
            : 'Your donation is processing.'}
        </h1>
        <p className="confirmation-copy">
          {isSuccess
            ? donationType === 'monthly'
              ? `Stripe confirmed your monthly gift of ${formatUsdCents(amountCents)}.`
              : `Stripe confirmed your donation of ${formatUsdCents(amountCents)}.`
            : `Stripe is still processing ${formatUsdCents(amountCents)}.`}{' '}
          {donorEmail ? `A receipt will be sent to ${donorEmail}.` : null}
        </p>

        <div className="confirmation-actions">
          <Link to="/give" className="button-primary tap-target">
            Give again
          </Link>
          <Link to="/contact" className="button-secondary tap-target">
            Contact Victoria&apos;s Place
          </Link>
        </div>
      </section>
    </div>
  );
}
